import { render, staticRenderFns } from "./videoItem.vue?vue&type=template&id=c26bae68&scoped=true"
import script from "./videoItem.vue?vue&type=script&lang=js"
export * from "./videoItem.vue?vue&type=script&lang=js"
import style0 from "./videoItem.vue?vue&type=style&index=0&id=c26bae68&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../../opt/deploy_node_modules/ailaworld/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c26bae68",
  null
  
)

export default component.exports